import { render, staticRenderFns } from "./CrmAiSettings.vue?vue&type=template&id=fba2b8e6&scoped=true"
import script from "./CrmAiSettings.vue?vue&type=script&lang=js"
export * from "./CrmAiSettings.vue?vue&type=script&lang=js"
import style0 from "./CrmAiSettings.vue?vue&type=style&index=0&id=fba2b8e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba2b8e6",
  null
  
)

export default component.exports